namespace $.$$ {

	export class $shm_projects_task extends $.$shm_projects_task {

		auto() {
			const run_id = this.run_id()
			if( run_id ) {
				this.task_poll_schedule()
				this.agent_bring_schedule()
			}
			return [
				... super.auto(),
				this.task_sync_auto(),
				...( run_id ? [ this.run_events().native() ] : [] ),
			]
		}

		@ $mol_mem
		agent_brought( next?: boolean ) {
			return next ?? false
		}

		agent_bring_schedule() {
			if( this.agent_brought() ) return null
			this.agent_brought( true )
			return new this.$.$mol_after_frame( ()=> {
				const page = this.Agent().Chat_page().dom_node() as HTMLElement
				let book = page.parentElement
				while( book && !book.hasAttribute( 'mol_book2' ) ) book = book.parentElement
				book?.scroll({
					left: page.offsetLeft + page.offsetWidth - book.clientWidth,
					behavior: 'smooth',
				})
			} )
		}

		private task_poll_timer: ReturnType< typeof setTimeout > | null = null

		task_poll_schedule() {
			if( this.task_poll_timer ) return this.task_poll_timer
			this.task_poll_timer = setTimeout( ()=> {
				this.task_poll_timer = null
				$mol_wire_async( this ).task_poll()
			}, 1000 )
			return this.task_poll_timer
		}

		task_poll() {
			const id = this.task_data().run_id
			if( !id ) return null
			const run = $mol_wire_sync( $shm_projects_goal_api ).run( id )
			this.run_receive( run )
			if( ![ 'done', 'failed', 'stopped' ].includes( run.status ) ) this.task_poll_schedule()
			return run
		}

		task_sync_auto() {
			const run = this.run_data()
			return run ? this.task_from_run( run ) : null
		}

		@ $mol_mem
		task_data( next?: $shm_projects_task_record ) {
			if( next !== undefined ) return next
			const task = this.$.$shm_projects_task_get( this.project_id(), this.task_id() )
			if( !task ) throw new Error( `Unknown task: ${ this.task_id() }` )
			return task
		}

		@ $mol_mem
		run_live( next?: $shm_projects_goal_run | null ) {
			return next ?? null
		}

		@ $mol_mem_key
		run_initial( id: string ) {
			if( !id ) return null
			return this.$.$mol_error_fence(
				()=> $mol_wire_sync( $shm_projects_goal_api ).run( id ),
				()=> null,
				promise => this.$.$mol_fail_hidden( promise ),
			)
		}

		run_data( next?: $shm_projects_goal_run | null ): $shm_projects_goal_run | null {
			if( next !== undefined ) return this.run_live( next )
			const id = this.run_id()
			if( !id ) return null
			const live = this.run_live()
			if( live?.id === id ) return live
			return this.run_initial( id )
		}

		run_id() {
			return this.task_data().run_id
		}

		@ $mol_mem
		run_events() {
			const events = new this.$.$shm_projects_goal_api_events
			events.id = ()=> this.run_id()
			events.notify = ()=> run => this.run_receive( run )
			return events
		}

		@ $mol_action
		run_receive( run: $shm_projects_goal_run ) {
			if( run.id === this.run_id() ) {
				this.run_data( run )
				this.task_from_run( run )
				this.Agent().refresh( this.Agent().refresh() + 1 )
			}
			return run
		}

		@ $mol_action
		task_from_run( run: $shm_projects_goal_run ) {
			const source = String( run.summary || '' ).trim()
			const description = source.match( /(?:^|\n)#{1,6}\s*Описание задачи\s*\n([\s\S]*?)(?=\n#{1,6}\s*Результат(?:ы)?\s*\n|$)/i )?.[1]?.trim()
			const result = source.match( /(?:^|\n)#{1,6}\s*Результат(?:ы)?\s*\n([\s\S]*)$/i )?.[1]?.trim()
			const current = this.task_data()
			const change: Partial< $shm_projects_task_record > = { status: run.status }
			if( description ) change.description = description
			if( result ) change.result = result
			if( change.status === current.status && ( change.description ?? current.description ) === current.description && ( change.result ?? current.result ) === current.result ) return current
			const next = this.$.$shm_projects_task_update( this.project_id(), this.task_id(), change )
			this.task_data( next )
			return next
		}

		task_title_rows() {
			return [ this.Task_title() ]
		}

		@ $mol_mem
		task_title_draft( next?: string ) {
			return next ?? this.task_data().title
		}

		@ $mol_action
		override task_title_commit( next?: Event ) {
			if( next === undefined ) return null
			const previous = this.task_data().title
			const title = this.task_title_draft().trim()
			if( !title ) this.task_title_draft( previous )
			else if( title !== previous ) this.task_data( this.$.$shm_projects_task_update( this.project_id(), this.task_id(), { title } ) )
			return next
		}

		@ $mol_action
		override task_title_keydown( next?: KeyboardEvent ) {
			if( next?.key !== 'Escape' ) return next ?? null
			next.preventDefault()
			this.task_title_draft( this.task_data().title )
			this.Task_title().focused( false )
			return next
		}

		@ $mol_mem
		description_draft( next?: string ) {
			return next ?? this.task_data().description
		}

		task_body() {
			return this.run_id()
				? [
					this.Description_card(),
					...( this.task_result() ? [ this.Result_card() ] : [] ),
				]
				: [ this.Description_draft() ]
		}

		send_agent_enabled() {
			return Boolean( this.description_draft().trim() )
		}

		@ $mol_action
		override send_agent( next?: Event ) {
			if( next === undefined ) return null
			const description = this.description_draft().trim()
			if( !description ) return next
			this.task_data( this.$.$shm_projects_task_update( this.project_id(), this.task_id(), { description } ) )
			const run = $mol_wire_sync( $shm_projects_goal_api ).task_start( this.project_id(), this.task_id(), description )
			this.task_data( this.$.$shm_projects_task_update( this.project_id(), this.task_id(), {
				run_id: run.id,
				status: run.status,
			}) )
			this.run_data( run )
			this.task_poll_schedule()
			this.agent_bring_schedule()
			return next
		}

		@ $mol_mem
		message_draft( next?: string ) {
			return next ?? ''
		}

		send_message_enabled() {
			const status = this.run_data()?.status
			return Boolean( this.message_draft().trim() ) && status !== 'queued' && status !== 'running' && status !== 'waiting'
		}

		@ $mol_action
		override send_message( next?: Event ) {
			if( next === undefined ) return null
			const message = this.message_draft().trim()
			if( !message || !this.send_message_enabled() ) return next
			const run = $mol_wire_sync( $shm_projects_goal_api ).task_message( this.run_id(), message )
			this.message_draft( '' )
			this.task_data( this.$.$shm_projects_task_update( this.project_id(), this.task_id(), { status: run.status } ) )
			this.run_data( run )
			this.task_poll_schedule()
			return next
		}

		override destructor() {
			if( this.task_poll_timer ) clearTimeout( this.task_poll_timer )
			this.task_poll_timer = null
			super.destructor()
		}

		task_iteration() {
			return this.run_data()?.iteration ?? 0
		}

		project_version() {
			return this.$.$shm_projects_data.version( this.project_id() )
		}

		workspace_id() {
			return this.run_data()?.workspace?.id ?? 'base'
		}

		summary_sections() {
			const source = String( this.run_data()?.summary || '' ).trim()
			return {
				description: source.match( /(?:^|\n)#{1,6}\s*Описание задачи\s*\n([\s\S]*?)(?=\n#{1,6}\s*Результат(?:ы)?\s*\n|$)/i )?.[1]?.trim() || this.task_data().description,
				result: source.match( /(?:^|\n)#{1,6}\s*Результат(?:ы)?\s*\n([\s\S]*)$/i )?.[1]?.trim()
					|| this.task_data().result
					|| ( this.run_data()?.status === 'done' ? source : '' ),
			}
		}

		task_description() {
			return this.summary_sections().description
		}

		task_result() {
			return this.summary_sections().result
		}

		agent_after() {
			return []
		}

		task_pages() {
			return [
				this.Details_page(),
				...( this.run_id() ? this.Agent().pages_deep() : [] ),
				...( this.run_id() && ( this.Agent() as any ).thinking_visible() ? [ this.Agent().Thinking() ] : [] ),
			]
		}

	}

}
